import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contato: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#f6f7f8] dark:bg-[#101922] font-sans py-20 px-6">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-slate-800 dark:text-white mb-8 text-center">Entre em Contato</h1>
                <div className="bg-white dark:bg-[#111827] rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                        <div className="flex flex-col gap-4">
                            <h3 className="text-xl font-bold text-slate-800 dark:text-white">Fale Conosco</h3>
                            <p className="text-slate-600 dark:text-slate-400">Estamos aqui para ajudar. Envie-nos uma mensagem ou entre em contato através dos nossos canais.</p>
                            <div className="flex flex-col gap-3 mt-4">
                                <div className="flex items-center gap-3 text-slate-600 dark:text-slate-400">
                                    <Mail className="text-[#137fec]" />
                                    <span>contato@construorca.com</span>
                                </div>
                                <div className="flex items-center gap-3 text-slate-600 dark:text-slate-400">
                                    <Phone className="text-[#137fec]" />
                                    <span>(11) 99999-9999</span>
                                </div>
                                <div className="flex items-center gap-3 text-slate-600 dark:text-slate-400">
                                    <MapPin className="text-[#137fec]" />
                                    <span>Av. Paulista, 1000 - São Paulo, SP</span>
                                </div>
                            </div>
                        </div>
                        <form className="flex flex-col gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="name">Nome</label>
                                <input className="w-full bg-gray-50 dark:bg-[#1F2937] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow" id="name" type="text" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="email">E-mail</label>
                                <input className="w-full bg-gray-50 dark:bg-[#1F2937] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow" id="email" type="email" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="message">Mensagem</label>
                                <textarea className="w-full bg-gray-50 dark:bg-[#1F2937] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg p-4 h-32 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow resize-none" id="message"></textarea>
                            </div>
                            <button type="submit" className="w-full flex items-center justify-center rounded-lg h-12 px-6 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30">
                                Enviar Mensagem
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contato;
